export default "__VITE_ASSET__dRjF9vUz__"